import { requestGet } from "@/utils/dva16";
import { EGet, NFAQ, RSetState } from "./contants";

export default {
	namespace: NFAQ,
	state: {
		faqList: null,
		load: false,
	},
	reducers: {
		[RSetState](state, { payload }) {
			return {
				...state,
				...payload,
			};
		},
	},
	effects: {
		async [EGet]({ payload, callback }, { call, reducer, select, effect }) {
			reducer(RSetState, { load: true });
			let res = await requestGet("faq", payload);
			reducer(RSetState, { faqList: res, load: false });
		},
	},
};
